/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Tools/SendAction/Content",
  isSubmitting
  
}) {
let messageComposeIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="message_compose"
 marginTop="auto"
 type="primary"
 size="small"
 marginRight={dtSpaceXs}
 marginBottom={8}
 onClick={onClick}
 disabled={messageComposeIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send now"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}